import axios from 'axios';
import store from '@/store';
import { API_BASE_URL } from '@/helpers/config';

export const API = axios.create({
  baseURL: API_BASE_URL,
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
  },
});

API.interceptors.request.use(
  (config) => {
    const $config = config;
    const $token = store.getters.jwtToken;
    if ($token) {
      $config.headers.Authorization = $token;
    }
    return $config;
  },

  (error) => {
    Promise.reject(error);
  },
);

API.interceptors.response.use(
  response => response,
  (error) => {
    if (error.response.status === 401) {
      store.commit('removeJwtToken');
      window.location.href = '/admin/login';
    }
    return Promise.reject(error);
  },
);

export default API;
